import React, { useState, useCallback, useEffect } from 'react';
// import AddCircle from '../../../../../static/assets/svg/mui-icons/AddCircle.svg';
// import Mail from '../../../../../static/assets/svg/mui-icons/Mail.svg';
// import HeadsetMic from '../../../../../static/assets/svg/mui-icons/HeadsetMic.svg';
// import Image from '../../../../../static/assets/svg/mui-icons/Image.svg';
import SideBarPopup from '../../../components/SideBarPopup/SideBarPopup';
import UpdatePower from '../../../components/MyAccount/MyDashboard/UpdatePower';
import UploadedPrescription from './UploadedPrescription';
import './CommonStyles.scss';
// import PowerDetails from '../../../../CommonComponents/PowerDetails/PowerDetails';

function AddPower(props) {
  const {
    setIsExpandable,
    isExpandable,
    cartData,
    setOpen,
    open,
    setMethodState,
    setShowFinalSubmitBtn,
    returnIdItem,
    currentItem,
    orderData,
    dataLocale,
    selectedPower,
    setSelectedPower,
    method,
    setMethod,
    isExchangeOnlyCase,
  } = props;
  const [showPrescription, showUploadedPresc] = useState(false);
  const {
    ADD_POWER,
    EXECUTIVE_GET_IN_TOUCH_FOR_PRESCRIPTION,
    WHAT_POWER_WOULD_YOU_LIKE_FOR_THIS_ITEM,
    VIEW_IMAGE,
    AP,
    AXIS,
    CYLINDER,
    SPHERICAL_POWER,
    ADD_NEW_POWER,
    LEFT,
    RIGHT,
    POWER_UPLOADED,
    ADD_POWER_PRESCRIPTION,
    POWER_NOT_KNOWN,
    CHANGE,
    PLEASE_SEND_US_COPY_OF_PRESCRIPTION,
    SUPPORT_EMAIL,
    POWER_PRESCRIPTION_ATTACHED,
  } = dataLocale;

  const showUploadPrescModal = useCallback(() => {
    showUploadedPresc(!showPrescription);
  }, [showPrescription]);

  const handleClick = () => {
    setOpen(true);
  };

  const getPowerDetails = () => {
    // if (currentItem && currentItem.prescriptionView) {
    //   return (
    //     <>
    //       <div className="margin-t10"><PowerDetails prescription={currentItem.prescriptionView} showUploadPrescModal={showUploadPrescModal} view="desktop" dataLocale={dataLocale} /></div>
    //       <div className="display-flex justify-content-between margin-t10 margin-l17 margin-b13 margin-r17">
    //       <div className="text-color-grey fs14 fw400">Power not known</div>
    //       <div className="text-uppercase text-link fs14 fw500" onClick={() => setOpen(true)}>Change</div>
    //       </div>
    //     </>
    //   )
    // } else {
    //   return (
    //     <div className="margin-l20 padding-9 display-flex">
    //       <AddCircleIcon className="margin-r12" style={{ color: '#00bac6', fontSize: '35px' }} />
    //       <div>
    //       <div className="text-uppercase text-link fs14 fw500" onClick={handleClick}>ADD NEW POWER</div>
    //       <div className="text-color-grey fs14 fw400">Upload Power Prescription / Take Photo or Enter power manually</div>
    //      </div>
    //    </div>
    //   )
    // }
    switch (true) {
      case method === 'callBack' && !open:
        return (
          <div className="margin-l20 padding-9">
            <div
              className="margin-r5 padding-10 display-flex align-items-center"
              style={{
                backgroundColor: 'rgb(255 198 115 / 39%)',
                width: '100%',
                borderRadius: '5px',
              }}
            >
              <img
                alt="mail-icon"
                className="margin-r12"
                src="https://static.lenskart.com/media/desktop/img/myorder/HeadsetMic.svg"
              />
              <span>{EXECUTIVE_GET_IN_TOUCH_FOR_PRESCRIPTION}</span>
            </div>
            <div className="display-flex justify-content-between margin-t10">
              <div className="text-color-grey fs14 fw400">{POWER_NOT_KNOWN}</div>
              <div className="text-uppercase text-link fs14 fw500" onClick={() => setOpen(true)}>
                {CHANGE}
              </div>
            </div>
          </div>
        );
      case method === 'successEmail' && !open:
        return (
          <div className="margin-l20 padding-9">
            <div
              className="margin-r5 padding-10 display-flex align-items-center"
              style={{ backgroundColor: 'rgb(255 198 115 / 39%)', width: '100%' }}
            >
              <img
                alt="mail-icon"
                className="margin-r12"
                src="https://static.lenskart.com/media/desktop/img/myorder/Mail.svg"
              />
              <div className="display-flex" style={{ flexDirection: 'column' }}>
                <span>{PLEASE_SEND_US_COPY_OF_PRESCRIPTION}</span>
                <span>{SUPPORT_EMAIL}</span>
              </div>
            </div>
            <div className="display-flex justify-content-between margin-t10">
              <div className="text-color-grey fs14 fw400">{POWER_NOT_KNOWN}</div>
              <div className="text-uppercase text-link fs14 fw500" onClick={() => setOpen(true)}>
                {CHANGE}
              </div>
            </div>
          </div>
        );
      case method === 'uploadPrescription' && Boolean(selectedPower) && !open:
        return (
          <div className="margin-l20 padding-9">
            <div
              className="margin-r5 padding-10 display-flex justify-content-between align-items-center fs14 fw400"
              style={{ backgroundColor: 'rgb(255 198 115 / 39%)', width: '100%' }}
            >
              <div className="display-flex align-items-center">
                <img
                  alt="images-icon"
                  className="margin-r12"
                  src="https://static.lenskart.com/media/desktop/img/myorder/Image.svg"
                />
                <span>{POWER_PRESCRIPTION_ATTACHED}</span>
              </div>
              <div className="fw500 cursor-pointer" onClick={showUploadPrescModal}>
                {VIEW_IMAGE}
              </div>
            </div>
            <div className="display-flex justify-content-between margin-t10">
              <div className="text-color-grey fs14 fw400">{POWER_UPLOADED}</div>
              <div className="text-uppercase text-link fs14 fw500" onClick={() => setOpen(true)}>
                {CHANGE}
              </div>
            </div>
          </div>
        );
      case method === 'savedPrescription' && Boolean(selectedPower) && !open:
      case method === 'enterPrescription' && Boolean(selectedPower) && !open:
        return (
          <div className="margin-l20 padding-9">
            <table className="tablePower">
              <thead>
                <tr>
                  <th></th>
                  <th>{SPHERICAL_POWER}</th>
                  <th>{CYLINDER}</th>
                  <th>{AXIS}</th>
                  <th>{AP}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    className="fs11 fw400"
                    style={{ color: 'rgba(60, 60, 60, 0.54)', textAlign: 'start' }}
                  >
                    {RIGHT}
                  </td>
                  <td>
                    {selectedPower.right && selectedPower.right.sph ? selectedPower.right.sph : '-'}
                  </td>
                  <td>
                    {selectedPower.right && selectedPower.right.cyl ? selectedPower.right.cyl : '-'}
                  </td>
                  <td>
                    {selectedPower.right && selectedPower.right.axis
                      ? selectedPower.right.axis
                      : '-'}
                  </td>
                  <td>
                    {selectedPower.right && selectedPower.right.ap ? selectedPower.right.ap : '-'}
                  </td>
                </tr>
                <tr>
                  <td
                    className="fs11 fw400"
                    style={{ color: 'rgba(60, 60, 60, 0.54)', textAlign: 'start' }}
                  >
                    {LEFT}
                  </td>
                  <td>
                    {selectedPower.left && selectedPower.left.sph ? selectedPower.left.sph : '-'}
                  </td>
                  <td>
                    {selectedPower.left && selectedPower.left.cyl ? selectedPower.left.cyl : '-'}
                  </td>
                  <td>
                    {selectedPower.left && selectedPower.left.axis ? selectedPower.left.axis : '-'}
                  </td>
                  <td>
                    {selectedPower.left && selectedPower.left.ap ? selectedPower.left.ap : '-'}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="display-flex justify-content-between margin-t10">
              <div className="text-color-grey fs14 fw400">{POWER_UPLOADED}</div>
              <div className="text-uppercase text-link fs14 fw500" onClick={() => setOpen(true)}>
                {CHANGE}
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div className="margin-l20 padding-9 display-flex">
            <img
              alt="add-circle"
              className="margin-r12"
              src="https://static.lenskart.com/media/desktop/img/myorder/AddCircle.svg"
            />
            <div>
              <div className="text-uppercase text-link fs14 fw500" onClick={handleClick}>
                {ADD_NEW_POWER}
              </div>
              <div className="text-color-grey fs14 fw400">{ADD_POWER_PRESCRIPTION}</div>
            </div>
          </div>
        );
    }
  };
  useEffect(() => {
    if (method?.length > 0) setShowFinalSubmitBtn(true);
    else setShowFinalSubmitBtn(false);
    if (method && currentItem) {
      getPowerDetails();
    }
  }, [currentItem, method]);

  return (
    <div className="bora-8 margin-10 order-box" style={{ minHeight: '120px' }}>
      {/* Fifth Accordion */}
      <div className={`padding-15 ${isExpandable !== ADD_POWER ? 'bg-white' : 'bg-cyan'}`}>
        <span
          className={`fs15 futur-std  ${
            isExpandable !== ADD_POWER ? 'text-color-grey fw500' : 'fw600'
          }`}
        >
          {`${
            isExchangeOnlyCase || returnIdItem ? 3 : 5
          }. ${WHAT_POWER_WOULD_YOU_LIKE_FOR_THIS_ITEM}`}
        </span>
        {isExpandable !== ADD_POWER && (
          <span
            className="float-right margin-r10 text-uppercase text-link"
            onClick={() => setIsExpandable(ADD_POWER)}
          >
            {CHANGE}
          </span>
        )}
      </div>
      {/* Power Selection Details according to selected power type */}
      {isExpandable === ADD_POWER && getPowerDetails()}
      {/* To Show Uploaded Prescription */}
      {showPrescription && Boolean(selectedPower) && (
        <UploadedPrescription
          prescriptionView={selectedPower}
          showPrescription={showPrescription}
          showUploadPrescModal={showUploadPrescModal}
        />
      )}
      {/* Open sidebar popup to show power option */}
      {open && (
        <SideBarPopup dialogClassName="power-type-modal" open={open} onClose={setOpen}>
          <UpdatePower
            isExchangeFlow
            item={cartData && cartData.items && cartData.items[0]}
            orderData={orderData}
            setMethod={setMethod}
            setMethodState={setMethodState}
            setOpen={setOpen}
            setSelectedPower={setSelectedPower}
            showPowerOptionsFn={() => {}}
          />
        </SideBarPopup>
      )}
    </div>
  );
}

export default AddPower;
